// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-07-16T10:45:53+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  188861
//    Project:        608
//    Environment:    7352 - master
//    MD5:            8cf911146eb9155641ee671622d22348
//    Signature:      eyJpdiI6IlwvN0RDOGlQcVFwUlRIdkJ5Z211RWV3PT0iLCJ2YWx1ZSI6IjYrK2pOdE5tSGtLUlBHc0hHY2pLMkJCa28rWUpQTEtBRjQwWDZZcmNEcFMwckdKMHQweDAzQ1FMUTh2YVh5ZjZSKzdHSFZobG0rZnhPVUtOQWZrb1dMWXFKQytsXC8xSHBwYTZ0MkhIWmwzQkYxUmttVmk1S0JFR3NcL3M5QldTR2dvemFkcDhDczhEZ3VmQmZ4elh2cXNic3VkM3c2cE1kS2N0YmxrSk55RG1DVmFrZUw0QWFsUkZwTzc3cDNhd1RoUzRVc1VjcGtteFBnZWthMWo5cHNVV2ttQUpQODVHbmJyK1ZURGFFVGROc042UU5ZbUNubEZcLysxQVZiNXZZVTBEUHBEcmdPMHc5YUtnajNnMUdNS0ZMaitwaXRWVTFyMDU2ZDhxMHlZaDdNcUNmWUxJaTFQQXVNOUpGc0Rwdmcrc1RxMVNNMHlkeGsxaEJORXhvMStCT1wvZ2c2NXRMNCtkWGhmNXFtUFVYR3B4N3dJdytWbnZGbm1OV0ZvODVMZGs5V1AzdlpaanhHZE8waTFUV0E3SHhBPT0iLCJtYWMiOiJmNzE4ZDQ5YjQzZWFiZTdmNWU1MWE3ZWRmNjM5MGNmNWM1ZTViOWFiOTA2MzRlMjY2YTNkZDQzN2Y3MDczNDk2In0=
(function () {
  function docReady(fn) {
    // see if DOM is already available
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  function findAddToCartButton(addToCartSelector) {
    let atcButton;
    if (addToCartSelector) {
      atcButton = document.querySelector(addToCartSelector);
    }

    // No ATC button. Try to find it by looking at the forms.
    if (!atcButton) {
      // find all forms that add to card.
      const allCartForms = document.querySelectorAll('form[action*="cart"]');
      // loop through them and find the one that has a button inside it. thats the atc button.
      for (const form of allCartForms) {
        const btn = form.querySelector(
          'button[type="submit"], input[type="submit"]'
        );
        if (btn) {
          atcButton = btn;
        }
      }
    }

    // Still no ATC:
    // Traverse DOM finding elements that match "Add to Cart"
    if (!atcButton) {
      for (const btn of document.querySelectorAll("button")) {
        if (
          btn.textContent.toLowerCase().includes("add to cart") &&
          !btn.classList.contains("no-js")
        ) {
          atcButton = btn;
        }
      }
    }

    // Still no submit button. Maybe its called "Add to basket"?
    if (!atcButton) {
      for (const btn of document.querySelectorAll("button")) {
        if (
          btn.textContent.toLowerCase().includes("add to basket") &&
          !btn.classList.contains("no-js")
        ) {
          atcButton = btn;
        }
      }
    }

    return atcButton;
  }

  function findBuyNowButton(selector) {
    let foundButton = document.querySelector(selector);
    // Could not find the button using Settings method.
    // Traverse DOM finding elements that match "Add to Cart"
    if (!foundButton) {
      for (const btn of document.querySelectorAll("button")) {
        if (
          btn.textContent.toLowerCase().includes("buy now") &&
          !btn.classList.contains("no-js")
        ) {
          foundButton = btn;
        }
      }
    }

    if (!foundButton) {
      for (const btn of document.querySelectorAll("button")) {
        if (
          btn.textContent.toLowerCase().includes("buy it now") &&
          !btn.classList.contains("no-js")
        ) {
          foundButton = btn;
        }
      }
    }

    //still no buy it now button?
    if (!foundButton) {
      foundButton = document.querySelector(".shopify-payment-button");
    }

    return foundButton;
  }

  docReady(function () {
    async function changeButtons() {
      // find the add to cart button
      const addToCartButton = findAddToCartButton();

      if (addToCartButton) {
        let data;

        // Check for productId. IF not exists, check for variant Id.
        if (ShopifyAnalytics.meta.product) {
          const resp = await fetch(
            `https://servicify-appointments.herokuapp.com/api/products/${ShopifyAnalytics.meta.product.id}/events?variantId=${ShopifyAnalytics.meta.selectedVariantId}`
          );
          data = await resp.json();
        } else if (ShopifyAnalytics.meta.selectedVariantId) {
          const resp = await fetch(
            `https://servicify-appointments.herokuapp.com/api/variants/${ShopifyAnalytics.meta.selectedVariantId}/events`
          );
          data = await resp.json();
        }

        if (data && data.isActive) {
          // hide the add cart button.
          addToCartButton.setAttribute(
            "data-original-text",
            addToCartButton.innerText
          );
          addToCartButton.setAttribute("disabled", true);
          addToCartButton.setAttribute("data-servicify-atc", true);
          addToCartButton.innerText = "Loading Available Slots";

          const buyNowButton = findBuyNowButton();
          if (buyNowButton) {
            buyNowButton.style.display = "none";
          }
        } else {
          console.log(
            "This product does not have an event associated with it."
          );
        }
      } else {
        console.log("No add to cart button found.");
      }

      window.SERVICIFY_HAS_UPDATED_BUTTON = true;
    }

    changeButtons();
  });
})();
